import MainContainerBase from './MainContainer';
import withLogin from '../../hoc/withLogin';
export default withLogin(MainContainerBase);
